import { render, staticRenderFns } from "./Integrate.vue?vue&type=template&id=3bd7b4e2&"
import script from "./Integrate.vue?vue&type=script&lang=js&"
export * from "./Integrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports